import "./App.css";
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import InternalJobBoard from "./components/InternalJobBoard";
import ProtectedRoute from "./components/auth/ProtectedRoute";

function App() {
  return (
    <Router>
      <Routes>
        {/* Root route - protected internal job board.
            The former public careers page lived here; it is now served from
            https://www.periscope365.com/careers instead. */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <InternalJobBoard />
            </ProtectedRoute>
          }
        />

        {/* Legacy route - kept so existing bookmarks and Auth0 returnTo
            values pointing at /internal-jobs still resolve. */}
        <Route path="/internal-jobs" element={<Navigate to="/" replace />} />

        {/* Catch-all route - everything else lands on the job board */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
